// Attuned Wellness and Endurance product pages (sections/ah-pdp.liquid), the motion and buying from the approved stills v1 page.
// The scan line marks the six systems on the first photo, the systems list swaps photo and points, How it works pins,
// the rescan line draws, messages slide into their own scrolling box, and every Add to cart opens the theme's cart drawer.
(() => {
  // every band section loads this file; run it once
  if (window.ahpJs) return; window.ahpJs = 1;
  const clamp = (x, a = 0, b = 1) => Math.min(b, Math.max(a, x));
  const pad2 = i => String(i + 1).padStart(2, '0');
  const phone = () => innerWidth <= 720;

  function init(root) {
    if (root.dataset.ahpReady) return; root.dataset.ahpReady = '1';
    const $ = s => root.querySelector(s), $$ = s => [...root.querySelectorAll(s)];
    let vh = innerHeight;
    const setVh = () => { vh = innerHeight; root.style.setProperty('--vh', vh + 'px'); };
    // the site header sticks to the top while scrolling: pinned parts sit just under it (its own height, not its bottom edge, which includes the bar at the top of the page)
    const hdrEl = document.querySelector('.ahc-hdr') || document.querySelector('.header-wrapper') || document.querySelector('.section-header');
    const setHdr = () => { const h = hdrEl ? hdrEl.offsetHeight : 0; root.style.setProperty('--hdr', h + 'px'); };
    // how far the site header reaches down into the hero (0 now that it sits above the page) and where the hero starts:
    // on desktop the buy panel and the photo labels start below it (Josh, Oct 28: too close to the nav)
    const navEl = document.querySelector('header'), heroEl = $('.hero');
    let over = 0;
    const setOver = () => { if (!navEl || !heroEl || scrollY > 10) return; over = Math.max(0, Math.round(navEl.getBoundingClientRect().bottom - heroEl.getBoundingClientRect().top)); root.style.setProperty('--over', over + 'px'); root.style.setProperty('--herotop', Math.round(heroEl.getBoundingClientRect().top + scrollY) + 'px'); };
    setVh(); setHdr(); setOver();

    // buy panel: one-time or subscribe; the delivery choices are the product's selling plans
    // the page is one section per band (Oct 29), so the one-time or subscribe choice is kept page-wide: the closing button and the dock buy what the panel shows
    const B = window.ahpBuy || (window.ahpBuy = { mode: 'one', plan: null });
    const all = s => [...document.querySelectorAll('[data-ahp] ' + s)];
    const atc0 = all('[data-atc][data-one]')[0], one = atc0 ? atc0.dataset.one : '';
    const freq = $$('.freq [data-plan]');
    const subp = $('[data-subp]');
    if (freq.length) B.plan = freq.find(b => b.classList.contains('on')) || freq[0];
    const showPrice = () => { const t = B.mode === 'sub' && B.plan ? B.plan.dataset.price : one; all('[data-atc-price]').forEach(e => e.textContent = t); };
    $$('.opt').forEach(o => o.addEventListener('click', () => {
      $$('.opt').forEach(x => x.classList.toggle('sel', x === o)); o.querySelector('input').checked = true;
      B.mode = o.dataset.opt; showPrice();
    }));
    freq.forEach(b => b.addEventListener('click', e => {
      e.preventDefault(); B.plan = b; freq.forEach(x => x.classList.toggle('on', x === b));
      if (subp) subp.textContent = b.dataset.price;
      const o = b.closest('.opt'); if (o && !o.classList.contains('sel')) o.click(); else showPrice();
    }));
    const variant = (all('[data-variant]')[0] || {}).dataset;
    $$('[data-atc]').forEach(btn => btn.addEventListener('click', async () => {
      if (!variant || btn.getAttribute('aria-disabled') === 'true') return;
      const wrap = btn.closest('[data-errwrap]'), err = wrap && wrap.querySelector('[data-err]');
      btn.setAttribute('aria-disabled', 'true'); if (err) err.hidden = true;
      const item = { id: +variant.variant, quantity: 1 };
      if (B.mode === 'sub' && B.plan) item.selling_plan = +B.plan.dataset.plan;
      try {
        const r = await fetch((window.routes && routes.cart_add_url ? routes.cart_add_url : '/cart/add') + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [item] }) });
        const d = await r.json();
        if (!r.ok || d.status) throw new Error(d.description || d.message || 'Could not add to cart. Please try again.');
        if (typeof updateCartCounts === 'function') updateCartCounts();
        if (typeof loadEgCartDrawer === 'function') loadEgCartDrawer(); else location.href = '/cart';
      } catch (x) { if (err) { err.textContent = x.message; err.hidden = false; } }
      finally { btn.removeAttribute('aria-disabled'); }
    }));

    // hero: the scan line sweeps once on load and marks the six systems as it passes
    const shot = $('[data-shot]'), heroImg = shot && shot.querySelector(':scope>img');
    const mks = $$('[data-mks] .mk'), heroPos = root.dataset.heroPos || '50% 50%';
    const timers = []; let placed = '';
    // the first photo's shape comes from its width/height attributes, so it holds while srcset swaps candidates
    const aw = +(heroImg && heroImg.getAttribute('width')) || 0, ah = +(heroImg && heroImg.getAttribute('height')) || 0;
    // positions are photo fractions, mapped through the object-fit crop so they stay off the person at every size
    function marks(animate = true) {
      if (!heroImg || !mks.length || shot.classList.contains('alt')) return;
      const W = shot.clientWidth, H = shot.clientHeight, iw = aw || heroImg.naturalWidth, ih = ah || heroImg.naturalHeight; if (!iw || !W) return;
      placed = W + 'x' + H;
      if (animate) timers.splice(0).forEach(clearTimeout);
      const sc = Math.max(W / iw, H / ih), [px, py] = heroPos.split(' ').map(x => parseFloat(x) / 100);
      const ox = (W - iw * sc) * (isNaN(px) ? .5 : px), oy = (H - ih * sc) * (isNaN(py) ? .5 : py);
      mks.forEach(m => {
        const side = m.dataset.side === 'l' ? 'l' : 'r', sp = m.querySelector('span');
        let x = ox + (+m.dataset.x / 100) * iw * sc;
        if (animate) m.classList.remove('on');
        m.classList.toggle('flip', side === 'l');
        m.style.top = Math.max(innerWidth > 720 ? over + 30 : 0, oy + (+m.dataset.y / 100) * ih * sc) + 'px';
        sp.style.maxWidth = Math.max(60, (side === 'l' ? x : W - x) - 30) + 'px';
        // on narrow screens nudge the marker in so its label never leaves the photo
        const lw = Math.max(sp.offsetWidth, sp.scrollWidth) + 17;
        x = side === 'l' ? Math.max(x, 8 + lw) : Math.min(x, W - 8 - lw);
        m.style.left = (side === 'l' ? x + 9 : x) + 'px';
        if (animate) timers.push(setTimeout(() => m.classList.add('on'), 500 + 2600 * x / W));
      });
    }
    // re-place (without replaying the fade) when the photo box changes size or the label fonts arrive
    if (shot && 'ResizeObserver' in window) new ResizeObserver(() => { if (placed && placed !== shot.clientWidth + 'x' + shot.clientHeight) marks(false); }).observe(shot);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => { if (placed) marks(false); });
    // the system markers belong to the first photo only
    const thumbBtns = $$('[data-thumb]');
    thumbBtns.forEach((b, i) => b.addEventListener('click', () => {
      if (!heroImg) return;
      thumbBtns.forEach(x => x.classList.toggle('on', x === b));
      shot.classList.toggle('alt', i > 0);
      heroImg.removeAttribute('srcset'); heroImg.srcset = b.dataset.srcset; heroImg.src = b.dataset.src;
      heroImg.style.objectPosition = i ? '50% 50%' : heroPos;
      if (!i) { if (heroImg.complete) marks(); else heroImg.addEventListener('load', marks, { once: true }); }
    }));
    if (heroImg) { if (heroImg.complete && heroImg.naturalWidth) marks(); else heroImg.addEventListener('load', marks, { once: true }); }
    const scan = $('[data-scan]'); if (scan) scan.classList.add('go');

    // how it works: the frame pins, the steps change
    const how = $('[data-how]'), hl = $$('[data-hl]>div'), hr = $$('[data-hr]>p'), hm = $$('[data-hf] .m'), bars = $$('[data-bars] b');
    const ns = hm.length; let step = -1;
    function drawHow(p) {
      if (!ns) return;
      const n = Math.min(ns - 1, Math.floor(p * ns)), w = clamp(p * ns - n);
      bars.forEach((b, i) => b.style.transform = `scaleX(${i < n ? 1 : i === n ? w : 0})`);
      if (n === step) return; step = n;
      [hl, hr].forEach(a => a.forEach((e, i) => e.classList.toggle('off', i !== n)));
      hm.forEach((e, i) => { e.classList.toggle('on', i === n); const vd = e.querySelector('video'); if (vd) i === n ? vd.play().catch(() => {}) : vd.pause(); });
    }
    // the six systems: on desktop the photo and its points follow the row at the middle of the screen
    const sxi = $$('.sxi'), sxim = $$('[data-sxf]>img'), sxov = $$('[data-sxf] .ov'), sxn = $('[data-sxn]'); let sxa = 0;
    function drawSys() {
      if (phone() || !sxi.length) return;
      let a = 0; sxi.forEach((li, i) => { if (li.getBoundingClientRect().top < vh * .5) a = i; });
      if (a === sxa) return; sxa = a;
      sxi.forEach((li, i) => li.classList.toggle('on', i === a)); sxim.forEach((im, i) => im.classList.toggle('on', i === a)); sxov.forEach((o, i) => o.classList.toggle('on', i === a));
      if (sxn) sxn.textContent = pad2(a);
    }
    const tl = $('[data-tl]'), tlln = $('[data-tlln]'), dots = $$('[data-tl] .dot'), hero = $('.hero'), dock = $('[data-dock]');
    function frame() {
      drawSys();
      if (how) { const r = how.getBoundingClientRect(); drawHow(clamp(-r.top / Math.max(1, how.offsetHeight - vh))); }
      if (tl && tlln) {
        const tp = clamp((vh * .85 - tl.getBoundingClientRect().top) / (vh * .5));
        tlln.style.transform = phone() ? `scaleY(${tp})` : `scaleX(${tp})`;
        dots.forEach((d, i) => d.classList.toggle('on', tp >= (i === 0 ? 0.02 : +d.dataset.at / 100)));
      }
      if (dock && hero) { const on = hero.getBoundingClientRect().bottom < 0; dock.classList.toggle('on', on); window.ahSetBar && ahSetBar(dock, on); }
    }
    let tick = false;
    addEventListener('scroll', () => { if (!tick) { tick = true; requestAnimationFrame(() => { tick = false; frame(); }); } }, { passive: true });
    frame();

    // one-shot reveals, the messages, videos that play only on screen
    const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!('IntersectionObserver' in window) || reduce) { $$('.rv,.msg,.sxi').forEach(e => e.classList.add('in')); }
    else {
      const io = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } }), { threshold: .2 });
      $$('.rv,.sxi').forEach(e => io.observe(e));
      // each message slides in as it scrolls into view inside the thread
      const th = $('[data-thread]');
      if (th) {
        const mio = new IntersectionObserver(es => { let k = 0; es.forEach(e => { if (e.isIntersecting) { const m = e.target; setTimeout(() => m.classList.add('in'), 250 + k++ * 380); mio.unobserve(m); } }); }, { root: th, threshold: .35 });
        new IntersectionObserver((es, o) => { if (es[0].isIntersecting) { o.disconnect(); $$('.msg').forEach(m => mio.observe(m)); } }, { threshold: .3 }).observe(th);
      }
    }
    if ('IntersectionObserver' in window) {
      const vio = new IntersectionObserver(es => es.forEach(e => e.isIntersecting ? e.target.play().catch(() => {}) : e.target.pause()), { threshold: .3 });
      $$('video[data-autoplay]').forEach(x => vio.observe(x));
    }
    let rw = innerWidth;
    addEventListener('resize', () => { setHdr(); setOver(); if (innerWidth !== rw) { rw = innerWidth; setVh(); marks(); frame(); } });
    addEventListener('load', setHdr);
  }

  const run = () => document.querySelectorAll('[data-ahp]').forEach(init);
  // the buy panel's Questions link points at the Questions band; hide it on a page without one
  const qlink = () => document.querySelectorAll('[data-ahp] a[href="#ahp-faq"]').forEach(x => { x.hidden = !document.getElementById('ahp-faq'); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => { run(); qlink(); }); else { run(); qlink(); }
  document.addEventListener('shopify:section:load', e => { const r = e.target.querySelector('[data-ahp]'); if (r) init(r); });
})();

// the chat bubble (Shopify Inbox) rises above whichever sticky buy bar is showing. Pages call ahSetBar(el, on);
// it sets --ah-bar on <html> (the bar's height plus its gap from the bottom, 0 when hidden). Shared by ah-home.js, ah-pdp.js and fss-page.js.
(function () {
  if (window.ahSetBar) return;
  window.ahSetBar = (el, on) => document.documentElement.style.setProperty('--ah-bar', (on && el && el.offsetHeight ? el.offsetHeight + (parseFloat(getComputedStyle(el).bottom) || 0) : 0) + 'px');
  const lift = () => {
    const h = document.querySelector('shopify-chat'), rt = h && h.shadowRoot && h.shadowRoot.querySelector('shopify-agent-runtime');
    const n = rt && rt.shadowRoot && rt.shadowRoot.querySelector('.activator-nudge'); if (!n) return;
    if (!n.dataset.ahBase) { n.dataset.ahBase = parseFloat(getComputedStyle(n).bottom) || 20; n.style.transition = 'bottom .3s ease'; }
    const bar = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--ah-bar')) || 0;
    const want = Math.max(+n.dataset.ahBase, bar ? bar + 14 : 0) + 'px';
    if (n.style.bottom !== want) n.style.bottom = want;
  };
  setInterval(lift, 400);
})();
